"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V3PermissionGroupIds_DisplayOrders = exports.V3PermissionGroupIds_Descriptions_English = exports.V3PermissionGroupIds_Descriptions = exports.V3PermissionGroupIds_translateDescriptionBack = exports.V3PermissionGroupIds_translateDescriptions = exports.V3PermissionGroupIds = void 0;
var V3PermissionGroupIds;
(function (V3PermissionGroupIds) {
    V3PermissionGroupIds[V3PermissionGroupIds["Administrators"] = 0] = "Administrators";
    V3PermissionGroupIds[V3PermissionGroupIds["Prescribers"] = 1] = "Prescribers";
    V3PermissionGroupIds[V3PermissionGroupIds["PatientForms"] = 2] = "PatientForms";
    V3PermissionGroupIds[V3PermissionGroupIds["Standard"] = 3] = "Standard";
    V3PermissionGroupIds[V3PermissionGroupIds["PatientFormsAdmin"] = 4] = "PatientFormsAdmin";
})(V3PermissionGroupIds = exports.V3PermissionGroupIds || (exports.V3PermissionGroupIds = {}));
function V3PermissionGroupIds_translateDescriptions(translationFunction) {
    var allKeys = Object.keys(exports.V3PermissionGroupIds_Descriptions);
    allKeys.forEach(function (key) {
        exports.V3PermissionGroupIds_Descriptions[key] = translationFunction(exports.V3PermissionGroupIds_Descriptions[key]);
    });
}
exports.V3PermissionGroupIds_translateDescriptions = V3PermissionGroupIds_translateDescriptions;
function V3PermissionGroupIds_translateDescriptionBack() {
    var allKeys = Object.keys(exports.V3PermissionGroupIds_Descriptions);
    allKeys.forEach(function (key) {
        exports.V3PermissionGroupIds_Descriptions[key] = exports.V3PermissionGroupIds_Descriptions_English[key];
    });
}
exports.V3PermissionGroupIds_translateDescriptionBack = V3PermissionGroupIds_translateDescriptionBack;
var _V3PermissionGroupIds_Descriptions = {};
_V3PermissionGroupIds_Descriptions.Administrators = _V3PermissionGroupIds_Descriptions[0] = "Administrators";
_V3PermissionGroupIds_Descriptions.Prescribers = _V3PermissionGroupIds_Descriptions[1] = "Prescribers";
_V3PermissionGroupIds_Descriptions.PatientForms = _V3PermissionGroupIds_Descriptions[2] = "PatientForms";
_V3PermissionGroupIds_Descriptions.Standard = _V3PermissionGroupIds_Descriptions[3] = "Standard";
_V3PermissionGroupIds_Descriptions.PatientFormsAdmin = _V3PermissionGroupIds_Descriptions[4] = "PatientFormsAdmin";
var _V3PermissionGroupIds_Descriptions_English = {};
_V3PermissionGroupIds_Descriptions_English.Administrators = _V3PermissionGroupIds_Descriptions_English[0] = "Administrators";
_V3PermissionGroupIds_Descriptions_English.Prescribers = _V3PermissionGroupIds_Descriptions_English[1] = "Prescribers";
_V3PermissionGroupIds_Descriptions_English.PatientForms = _V3PermissionGroupIds_Descriptions_English[2] = "PatientForms";
_V3PermissionGroupIds_Descriptions_English.Standard = _V3PermissionGroupIds_Descriptions_English[3] = "Standard";
_V3PermissionGroupIds_Descriptions_English.PatientFormsAdmin = _V3PermissionGroupIds_Descriptions_English[4] = "PatientFormsAdmin";
exports.V3PermissionGroupIds_Descriptions = _V3PermissionGroupIds_Descriptions;
exports.V3PermissionGroupIds_Descriptions_English = _V3PermissionGroupIds_Descriptions_English;
var _V3PermissionGroupIds_DisplayOrders = {};
_V3PermissionGroupIds_DisplayOrders.Administrators = _V3PermissionGroupIds_DisplayOrders[0] = 0;
_V3PermissionGroupIds_DisplayOrders.Prescribers = _V3PermissionGroupIds_DisplayOrders[1] = 1;
_V3PermissionGroupIds_DisplayOrders.PatientForms = _V3PermissionGroupIds_DisplayOrders[2] = 2;
_V3PermissionGroupIds_DisplayOrders.Standard = _V3PermissionGroupIds_DisplayOrders[3] = 3;
_V3PermissionGroupIds_DisplayOrders.PatientFormsAdmin = _V3PermissionGroupIds_DisplayOrders[4] = 4;
exports.V3PermissionGroupIds_DisplayOrders = _V3PermissionGroupIds_DisplayOrders;
